// ----------------------------------------------------------------------
const data = JSON.parse(localStorage.getItem('user'));

const account = {
  displayName: data && data.name ? data.name : 'Name not added',
  email: data && data.email,
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
